import Entity from './entity'
export default class PickListPicking extends Entity<number>{
    productId : number;
    productName : string;
    sku : string;
    storageType : string;
    thumbnailUrl : string;
    qty : number;
    pickedQty : number;
    pickedLocationTransportId : number;
    pickedLocationTransportCode : string;
    allocatedLocationBinId : number;
    allocatedLocationBinCode : string;
    refId : number;
    refCode : string;
    pickedBy : number;
    pickedByName : string;
    pickedTime : Date;
    serialNoes : Array<string>;
    storageTypeName:string;
    rePickedBy : number;
    rePickedByName : string;
    rePickedTime : Date;
}